import { gql } from 'apollo-angular';

export const PerformPromptBaseOnCompanyDataDocument = gql`
  mutation performPromptBaseOnCompanyData($input: PerformPromptBaseOnCompanyDataInput!) {
    performPromptBaseOnCompanyData(input: $input)
  }
`;
